import { useQuery } from '@tanstack/react-query';
import type { ClaudeUsageRange } from '../types/api.js';
import { claudeUsageApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * bot 別の Claude 利用状況取得フック。
 *
 * bot-status（5 分ごとの push）と違い、こちらは Grafana へのクエリなので取得のたびに
 * 外部サービスを叩く。秒単位で変わる値でもないため、再取得は控えめにする。
 *
 * @graph-stack cortex-admin
 * @graph-domain Infrastructure
 * @graph-business bot 別 Claude 利用状況の取得フック。TanStack Query で期間別にキャッシュする。
 * @graph-connects claudeUsageApi [calls] claude-usage 最新データ API クライアント呼び出し
 * @graph-connects queryKeys [calls] TanStack Query キー生成
 */
export function useClaudeUsage(range: ClaudeUsageRange) {
  return useQuery({
    queryKey: queryKeys.claudeUsage.latest(range),
    queryFn: () => claudeUsageApi.getLatest(range),
    refetchInterval: 300_000,
    refetchOnWindowFocus: false,
  });
}
